import { torontoDateParts, torontoDayOfMonth, torontoMonthKey } from "@utils";

import DateStatCard from "./DateStatCard";
import MultiSelectDropdown from "./MultiSelectDropdown";
import StatCard from "./StatCard";

// helper: current month in YYYY-MM
export const getCurrentMonth = () => torontoMonthKey();

// helper: previous (last completed) month in YYYY-MM
export const getLastCompletedMonth = () => {
  const { year, month } = torontoDateParts();
  const prevMonth = month === 1 ? 12 : month - 1;
  const prevYear = month === 1 ? year - 1 : year;
  return `${prevYear}-${String(prevMonth).padStart(2, "0")}`;
};

// helper: default payroll month based on the day of the month.
//   - On or after the 25th, default to the current month.
//   - Before the 25th, default to the previous (last completed) month.
export const getDefaultPayrollMonth = () => {
  return torontoDayOfMonth() >= 25 ? getCurrentMonth() : getLastCompletedMonth();
};

export default function MonthlyClinicSelection({
  /**
   * Which date selector to render before the clinic card:
   *   - "month" (default): month picker
   *   - "date": single calendar-date picker
   *   - "none": no date selector (clinic-only)
   */
  mode = "month",
  months = [],
  onMonthsChange,
  /** Single-date value (YYYY-MM-DD) used when mode="date". */
  date = "",
  onDateChange,
  disableCurrentAndFuture = true,
  monthLabel = "Month",
  dateLabel = "Date",

  clinicOptions = [],
  clinicValue = [],
  onClinicChange,
  clinicLabel = "Clinic",
  clinicPlaceholder = "All Clinics",
  clinicEmptyLabel = "All Clinics",
  clinicAriaLabel = "Filter by clinic",

  /** Optional node rendered between the Month/Date and Clinic cards (e.g. Area Manager). */
  betweenSlot = null,
}) {
  const handleMonthChange = (m) => {
    onMonthsChange?.(m ? [m] : []);
  };

  return (
    <>
      {mode === "date" ? (
        <DateStatCard mode="single" label={dateLabel} value={date} onChange={onDateChange} />
      ) : mode === "none" ? null : (
        <DateStatCard
          mode="month"
          label={monthLabel}
          monthValue={months[0] || ""}
          onChangeMonth={handleMonthChange}
          disableCurrentAndFuture={disableCurrentAndFuture}
        />
      )}
      {betweenSlot}
      <StatCard icon="🏥" label={clinicLabel}>
        <div className="mt-2">
          <MultiSelectDropdown
            options={clinicOptions}
            value={clinicValue}
            onChange={onClinicChange}
            placeholder={clinicPlaceholder}
            emptyLabel={clinicEmptyLabel}
            ariaLabel={clinicAriaLabel}
          />
        </div>
      </StatCard>
    </>
  );
}
